import { render } from "./salesNotesComponent.vue?vue&type=template&id=ed749806&scoped=true"
import script from "./salesNotesComponent.vue?vue&type=script&lang=js"
export * from "./salesNotesComponent.vue?vue&type=script&lang=js"

import "./salesNotesComponent.vue?vue&type=style&index=0&id=ed749806&scoped=true&lang=css"
import "./salesNotesComponent.vue?vue&type=style&index=1&id=ed749806&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed749806"]])

export default __exports__